import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import PropTypes from "prop-types";

import MarkerIcon from "images/marker-icon.png";

const icon = new L.Icon({
	iconUrl: MarkerIcon,
	iconRetinaUrl: MarkerIcon,
	iconAnchor: null,
	popupAnchor: null,
	shadowUrl: null,
	shadowSize: null,
	shadowAnchor: null,
	iconSize: new L.Point(20, 32),
});

const Component = ({ latitude, longitude }) => {
	return !!latitude && !!longitude ? (
		<MapContainer
			center={{
				lat: latitude,
				lng: longitude,
			}}
			length={4}
			zoom={13}
			style={{ height: 220, width: "100%" }}
		>
			<Marker
				position={[latitude, longitude]}
				icon={icon}
			/>
			<TileLayer
				attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
				url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
			/>
		</MapContainer>
	) : (
		<></>
	);
};

Component.propTypes = {
	latitude: PropTypes.any,
	longitude: PropTypes.any,
};

export default Component;
